// Bridge constants
export const LOGIN_BRIDGE = {
    RECAPTCHA_CONTAINER_ID: 'recaptcha-container',
    /** Opção `size` do widget reCAPTCHA (Firebase). */
    RECAPTCHA_SIZE: 'invisible',
    /** Prefixo E.164 fixo para Brasil no MVP. */
    E164_BR_PREFIX: '+55',
    /** Mínimo de dígitos nacionais (DDD + número). */
    MIN_NATIONAL_DIGITS: 10,
  } as const;


// Form constants
export const LOGIN_FORM_CODE_SENT_PREFIX = 'Código enviado para';
export const LOGIN_FORM_CHANGE_NUMBER = 'Alterar número';
export const LOGIN_FORM_OTP_LABEL = 'Código de verificação';
export const LOGIN_FORM_RESEND = 'Reenviar código';
export const LOGIN_FORM_RESEND_IN = (seconds: number) => `Reenviar em ${seconds}s`;
export const LOGIN_FORM_VERIFY = 'Verificar';
export const LOGIN_FORM_VERIFY_LOADING = 'Verificando';
export const LOGIN_FORM_OTP_STATUS_VERIFYING = 'Verificando...';
export const LOGIN_FORM_OTP_STATUS_INVALID = 'Código inválido. Tente novamente.';
export const LOGIN_FORM_OTP_STATUS_VERIFIED = 'Número verificado!';
export const LOGIN_FORM_OTP_VERIFY_MIN_DISPLAY_MS = 1000;
export const LOGIN_FORM_OTP_SUCCESS_HOLD_MS = 1000;
export const LOGIN_FORM_PHONE_LABEL = 'WhatsApp';
export const LOGIN_FORM_PHONE_PLACEHOLDER = '+55 (00) 00000-0000';
export const LOGIN_FORM_SEND_CODE = 'Enviar código';
export const LOGIN_FORM_SEND_LOADING = 'Enviando';
export const LOGIN_FORM_OR_CONTINUE = 'ou continue com';
export const LOGIN_FORM_PHONE_DISPLAY_FALLBACK = '+55 (00) 00000-0000';
export const LOGIN_FORM_SUCCESS_TOAST_MESSAGE = 'Login realizado!';
export const LOGIN_FORM_RESEND_COOLDOWN_TICK_MS = 1000;
export const LOGIN_FORM_RESEND_COOLDOWN_SECONDS = 60;
export const LOGIN_FORM_OTP_DIGIT_COUNT = 6;
export const LOGIN_FORM_MIN_NATIONAL_PHONE_DIGITS = LOGIN_BRIDGE.MIN_NATIONAL_DIGITS;
